import { render } from "./PageFormDataOrangTua.vue?vue&type=template&id=2bd2c7da"
import script from "./PageFormDataOrangTua.vue?vue&type=script&lang=js"
export * from "./PageFormDataOrangTua.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__